import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import ThemeSelector from "./pages/ThemeSelector";
import PublicProfile from "./pages/PublicProfile";
import ProtectedRoute from "./utils/ProtectedRoute";
import Home from "./pages/Home";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/theme"
          element={
            <ProtectedRoute>
              <ThemeSelector />
            </ProtectedRoute>
          }
        />
        <Route path="/u/:username" element={<PublicProfile />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
